import { ComponentEntity } from "src/app/core/entities/component.entity";
import { ServiceBookItemFormModel } from "../service-book-item.form-model";

export class Twenty47RequestFormModel
extends ServiceBookItemFormModel {

}